export function isFormRenderView(field) {
    return typeof field === 'object' && field !== null && 'key' in field;
}
export function isFormRenderViewMap(field) {
    return typeof field === 'object' && !Array.isArray(field) && field !== null;
}
export function isFormRenderViewMapArray(field) {
    return Array.isArray(field);
}
export function isObjectElement(element, fieldConfigMap) {
    let type = fieldConfigMap[element.configName]?.type;
    let isObjectType = type === "composedList" || type === "form" || type === "composed" || element.fieldPath === "" || element.cardSection;
    return isObjectType && isFormRenderViewMap(element.value);
}
export function isBasicFieldElement(field, fieldConfigMap) {
    return !isObjectElement(field, fieldConfigMap);
}
export function isArrayElement(element, fieldConfigMap) {
    let type = fieldConfigMap[element.configName]?.type;
    let isArrayType = type === "composedList" || element.cardSection;
    return isArrayType && isFormRenderViewMapArray(element.value);
}
